// import { useState, useEffect, useRef } from "react";
// import { api, handleAuthFailure } from "../data/api";
// import { useTheme } from "../context/ThemeContext";
// import HaivisionStatsTab from "../components/HaivisionStatsTab";

// // ── Sparkline ─────────────────────────────────────────────────────────────────
// function Sparkline({ data, color, height = 48 }) {
//   if (!data || data.length < 2) {
//     return <div style={{ height, background: "var(--surface-alt)", borderRadius: 4 }} />;
//   }
//   const w = 300, h = height;
//   const min = Math.min(...data), max = Math.max(...data);
//   const range = max - min || 1;
//   const pts = data
//     .map((v, i) => `${(i / (data.length - 1)) * w},${h - ((v - min) / range) * (h - 6) - 3}`)
//     .join(" ");
//   const area = `${pts} ${w},${h} 0,${h}`;
//   return (
//     <svg viewBox={`0 0 ${w} ${h}`} style={{ width: "100%", height }} preserveAspectRatio="none">
//       <polygon points={area} fill={color} opacity="0.12" />
//       <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );
// }

// // ── Animated speedometer ──────────────────────────────────────────────────────
// function Speedometer({ channel, onClick, animKey }) {
//   const [animProgress, setAnimProgress] = useState(0);
//   const animRef = useRef(null);

//   const now = new Date();
//   const lastHb = channel.last_heartbeat ? new Date(channel.last_heartbeat) : null;
//   const minsSinceHb = lastHb ? (now - lastHb) / 60000 : Infinity;

//   let color, label, glow, targetFill;
//   if (channel.status !== "active") {
//     color = "#ef4444"; label = "Inactive"; glow = "rgba(239,68,68,0.25)"; targetFill = 0.15;
//   } else if (minsSinceHb <= 10) {
//     color = "#22c55e"; label = "Active"; glow = "rgba(34,197,94,0.25)"; targetFill = 1;
//   } else {
//     color = "#f59e0b"; label = "No Heartbeat"; glow = "rgba(245,158,11,0.25)"; targetFill = 0.5;
//   }

//   // Animate from 0 to targetFill on mount
//   useEffect(() => {
//     setAnimProgress(0);
//     let start = null;
//     const duration = 1200;
//     const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

//     const step = (ts) => {
//       if (!start) start = ts;
//       const elapsed = ts - start;
//       const progress = Math.min(elapsed / duration, 1);
//       setAnimProgress(ease(progress) * targetFill);
//       if (progress < 1) animRef.current = requestAnimationFrame(step);
//     };
//     animRef.current = requestAnimationFrame(step);
//     return () => cancelAnimationFrame(animRef.current);
//   }, [channel.id, targetFill, animKey]);

//   const R = 38, cx = 56, cy = 58;
//   const toRad = (d) => (d * Math.PI) / 180;
//   const START_ANGLE = -210, END_ANGLE = 30;
//   const SWEEP = END_ANGLE - START_ANGLE;

//   const arcPath = (start, end, r) => {
//     const s = { x: cx + r * Math.cos(toRad(start)), y: cy + r * Math.sin(toRad(start)) };
//     const e = { x: cx + r * Math.cos(toRad(end)),   y: cy + r * Math.sin(toRad(end))   };
//     const large = Math.abs(end - start) > 180 ? 1 : 0;
//     return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
//   };

//   const fillEndAngle = START_ANGLE + SWEEP * animProgress;

//   // Needle angle
//   const needleAngle = START_ANGLE + SWEEP * animProgress;
//   const needleLen = R - 10;
//   const nx = cx + needleLen * Math.cos(toRad(needleAngle));
//   const ny = cy + needleLen * Math.sin(toRad(needleAngle));

//   return (
//     <div
//       onClick={onClick}
//       style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 10, padding: "14px 10px 10px", cursor: "pointer", transition: "border-color 0.18s, box-shadow 0.18s", userSelect: "none" }}
//       onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.boxShadow = `0 0 0 3px ${glow}`; }}
//       onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.boxShadow = "none"; }}
//     >
//       <svg viewBox="0 0 112 80" style={{ width: 112, height: 80, overflow: "visible" }}>
//         {/* Outer glow ring */}
//         {animProgress > 0.9 && channel.status === "active" && minsSinceHb <= 10 && (
//           <circle cx={cx} cy={cy} r={R + 10} fill="none" stroke={color} strokeWidth="1" opacity="0.15" />
//         )}
//         {/* Track background */}
//         <path d={arcPath(START_ANGLE, END_ANGLE, R)} fill="none" stroke={"var(--surface-alt)"} strokeWidth="8" strokeLinecap="round" />
//         {/* Coloured fill — animated */}
//         {animProgress > 0 && (
//           <path
//             d={arcPath(START_ANGLE, fillEndAngle, R)}
//             fill="none"
//             stroke={color}
//             strokeWidth="8"
//             strokeLinecap="round"
//             style={{ filter: `drop-shadow(0 0 5px ${glow})` }}
//           />
//         )}
//         {/* Tick marks */}
//         {[0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1].map((t, i) => {
//           const angle = START_ANGLE + SWEEP * t;
//           const ir = R - 5, or = R + 3;
//           return (
//             <line key={i}
//               x1={cx + ir * Math.cos(toRad(angle))} y1={cy + ir * Math.sin(toRad(angle))}
//               x2={cx + or * Math.cos(toRad(angle))} y2={cy + or * Math.sin(toRad(angle))}
//               stroke={"var(--border-strong)"} strokeWidth="1" strokeLinecap="round"
//             />
//           );
//         })}
//         {/* Needle */}
//         <line x1={cx} y1={cy} x2={nx} y2={ny} stroke={color} strokeWidth="2" strokeLinecap="round" />
//         <circle cx={cx} cy={cy} r="4" fill={color} style={{ filter: `drop-shadow(0 0 3px ${glow})` }} />
//         <circle cx={cx} cy={cy} r="2" fill="#fff" />
//       </svg>

//       <div style={{ fontSize: 11, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace", marginBottom: 2 }}>
//         {channel.id}
//       </div>
//       <div style={{ fontSize: 10, color: "var(--text-sub)", marginBottom: 6, maxWidth: 100, textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//         {channel.display_name}
//       </div>
//       <div style={{ display: "flex", alignItems: "center", gap: 4, background: color + "18", border: `1px solid ${color}44`, borderRadius: 20, padding: "2px 8px" }}>
//         <div style={{ width: 6, height: 6, borderRadius: "50%", background: color,
//           animation: channel.status === "active" && minsSinceHb <= 10 ? "pulse 2s infinite" : "none"
//         }} />
//         <span style={{ fontSize: 10, fontWeight: 700, color, letterSpacing: "0.04em" }}>{label}</span>
//       </div>
//       <div style={{ fontSize: 10, color: "var(--text-dim)", marginTop: 5 }}>
//         {channel.device_count} device{channel.device_count !== 1 ? "s" : ""}
//         {" · "}{channel.affiliate_count} affiliate{channel.affiliate_count !== 1 ? "s" : ""}
//       </div>
//     </div>
//   );
// }

// // ── Stat card ─────────────────────────────────────────────────────────────────
// function StatCard({ label, value, sub, accent }) {
//   return (
//     <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 9, padding: "16px 18px", flex: 1, minWidth: 0 }}>
//       <div style={{ fontSize: 11, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 8 }}>{label}</div>
//       <div style={{ fontSize: 28, fontWeight: 700, color: accent || "var(--ink)", fontVariantNumeric: "tabular-nums", lineHeight: 1, letterSpacing: "-0.02em" }}>{value ?? "—"}</div>
//       {sub && <div style={{ fontSize: 11, color: "var(--text-sub)", marginTop: 5 }}>{sub}</div>}
//     </div>
//   );
// }

// // ── metric bar ───────────────────────────────────────────────────────────
// function MetricBar({ label, value, unit, color }) {
//   const pct = Math.min(100, Math.max(0, Number(value) || 0));
//   const barColor = pct > 85 ? "#ef4444" : pct > 65 ? "#f59e0b" : color || "#22c55e";
//   return (
//     <div style={{ marginBottom: 8 }}>
//       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
//         <span style={{ fontSize: 10, color: "var(--text-sub)", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</span>
//         <span style={{ fontSize: 11, fontWeight: 600, color: "var(--ink)", fontVariantNumeric: "tabular-nums" }}>
//           {value != null ? `${Number(value).toFixed(1)}${unit}` : "—"}
//         </span>
//       </div>
//       <div style={{ height: 4, background: "var(--surface-alt)", borderRadius: 2, overflow: "hidden" }}>
//         <div style={{ width: `${pct}%`, height: "100%", background: barColor, borderRadius: 2, transition: "width 0.4s" }} />
//       </div>
//     </div>
//   );
// }

// function AffiliateModal({ affiliateId, onClose }) {
//   const [data, setData]       = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr]         = useState(null);

//   useEffect(() => {
//     setLoading(true);
//     api.affiliates.detail(affiliateId)
//       .then(d => { setData(d); setErr(null); })
//       .catch(e => {
//         if (handleAuthFailure(e)) return;
//         setErr(e.message || "Failed to load affiliate");
//       })
//       .finally(() => setLoading(false));
//   }, [affiliateId]);

//   const devices = data?.devices || [];
//   const onlinePct = devices.length
//     ? Math.round((devices.filter(d => d.status === "online").length / devices.length) * 100)
//     : 0;

//   return (
//     <div
//       onClick={e => { if (e.target === e.currentTarget) onClose(); }}
//       style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
//     >
//       <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: 560, maxHeight: "82vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
//         <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
//           <div>
//             <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>{data?.affiliate?.org_name || affiliateId}</div>
//             <div style={{ fontSize: 11, color: "var(--text-dim)", fontFamily: "'IBM Plex Mono', monospace", marginTop: 2 }}>{affiliateId}</div>
//           </div>
//           <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, color: "var(--text-dim)", cursor: "pointer" }}>×</button>
//         </div>
//         <div style={{ padding: 20, overflowY: "auto" }}>
//           {loading ? (
//             <div style={{ fontSize: 12, color: "var(--text-dim)", textAlign: "center", padding: "30px 0" }}>Loading…</div>
//           ) : err ? (
//             <div style={{ fontSize: 12, color: "#8b1f1f" }}>{err}</div>
//           ) : (
//             <>
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18, fontSize: 12 }}>
//                 <div><span style={{ color: "var(--text-dim)" }}>Contact: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.contact_name || "—"}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>Email: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.contact_email || "—"}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>Region: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.region || "—"}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>Status: </span><span style={{ color: data.affiliate.status === "active" ? "#1a7a42" : "var(--text-sub)", fontWeight: 600, textTransform: "capitalize" }}>{data.affiliate.status}</span></div>
//               </div>

//               <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
//                 Device Fleet Health
//               </div>
//               <MetricBar label="Devices Online" value={onlinePct} unit="%" />
//               <div style={{ fontSize: 11, color: "var(--text-sub)", marginBottom: 18 }}>
//                 {devices.filter(d => d.status === "online").length} of {devices.length} device(s) online
//               </div>

//               <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>
//                 Channels ({data.channels?.length || 0})
//               </div>
//               <div style={{ fontSize: 12, color: "var(--text-sub)", marginBottom: 18 }}>
//                 {data.channels?.length ? data.channels.map(c => c.display_name).join(", ") : "No channels assigned."}
//               </div>

//               <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>
//                 Devices ({devices.length})
//               </div>
//               {devices.length === 0 ? (
//                 <div style={{ fontSize: 12, color: "var(--text-dim)" }}>No devices assigned.</div>
//               ) : devices.map(d => (
//                 <div key={d.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid var(--border)`, fontSize: 12 }}>
//                   <span style={{ fontFamily: "'IBM Plex Mono', monospace", color: "var(--ink)" }}>{d.id}</span>
//                   <span style={{ color: d.status === "online" ? "#1a7a42" : "var(--text-sub)", textTransform: "capitalize" }}>{d.status}</span>
//                 </div>
//               ))}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function DeviceModal({ deviceId, onClose }) {
//   const [dev, setDev]         = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr]         = useState(null);

//   useEffect(() => {
//     setLoading(true);
//     api.devices.get(deviceId)
//       .then(d => { setDev(d); setErr(null); })
//       .catch(e => {
//         if (handleAuthFailure(e)) return;
//         setErr(e.message || "Failed to load device");
//       })
//       .finally(() => setLoading(false));
//   }, [deviceId]);

//   return (
//     <div
//       onClick={e => { if (e.target === e.currentTarget) onClose(); }}
//       style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
//     >
//       <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: 480, maxHeight: "82vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
//         <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
//           <div>
//             <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{deviceId}</div>
//             {dev && <div style={{ fontSize: 11, color: dev.status === "online" ? "#1a7a42" : "var(--text-sub)", textTransform: "capitalize", marginTop: 2 }}>{dev.status}</div>}
//           </div>
//           <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, color: "var(--text-dim)", cursor: "pointer" }}>×</button>
//         </div>
//         <div style={{ padding: 20, overflowY: "auto" }}>
//           {loading ? (
//             <div style={{ fontSize: 12, color: "var(--text-dim)", textAlign: "center", padding: "30px 0" }}>Loading…</div>
//           ) : err ? (
//             <div style={{ fontSize: 12, color: "#8b1f1f" }}>{err}</div>
//           ) : (
//             <>
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18, fontSize: 12 }}>
//                 <div><span style={{ color: "var(--text-dim)" }}>MAC: </span><span style={{ color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.mac_address || "—"}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>IP: </span><span style={{ color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.ip_address || "—"}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>Model: </span><span style={{ color: "var(--ink)" }}>{dev.device_type === "self-srt-connect" ? "" : (dev.device_model || "—")}</span></div>
//                 <div><span style={{ color: "var(--text-dim)" }}>Affiliate: </span><span style={{ color: "var(--ink)" }}>{dev.affiliate_id || "Unassigned"}</span></div>
//               </div>

//               <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
//                 Live Metrics
//               </div>
//               <MetricBar label="CPU"  value={dev.cpu_usage}   unit="%" />
//               <MetricBar label="RAM"  value={dev.ram_usage}   unit="%" />
//               <MetricBar label="Disk" value={dev.disk_usage}  unit="%" />
//               <MetricBar label="Temp" value={dev.temperature} unit="°C" />
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function ChannelModal({ channel, affiliates, devices, onClose }) {
//   const [tab, setTab] = useState("affiliates"); // "affiliates" | "devices" | "live-stats"
//   const [affSearch, setAffSearch]   = useState("");
//   const [devSearch, setDevSearch]   = useState("");

//   const now = new Date();
//   const lastHb = channel.last_heartbeat ? new Date(channel.last_heartbeat) : null;
//   const minsSinceHb = lastHb ? (now - lastHb) / 60000 : Infinity;
//   let color, statusLabel;
//   if (channel.status !== "active")  { color = "#ef4444"; statusLabel = "Inactive"; }
//   else if (minsSinceHb <= 10)       { color = "#22c55e"; statusLabel = "Active — Heartbeat OK"; }
//   else                              { color = "#f59e0b"; statusLabel = "Active — No Heartbeat"; }

//   const myAffiliates = affiliates.filter(a => a.channel_id === channel.id);
//   const myDevices    = devices.filter(d => d.channel_id === channel.id);

//   return (
//     <div
//       onClick={e => { if (e.target === e.currentTarget) onClose(); }}
//       style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
//     >
//       <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: tab === "live-stats" ? "min(92vw, 1060px)" : 640, maxHeight: tab === "live-stats" ? "90vh" : "82vh", height: tab === "live-stats" ? "90vh" : undefined, transition: "width 0.2s ease", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>

//         {/* Header */}
//         <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <span style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{channel.id}</span>
//               <span style={{ fontSize: 13, color: "var(--text-sub)" }}>{channel.display_name}</span>
//               {channel.quality && (
//                 <span style={{ background: channel.quality === "HD" ? "#eef3fb" : "var(--surface-alt)", color: channel.quality === "HD" ? "#1d4e8a" : "var(--text-sub)", border: `1px solid ${channel.quality === "HD" ? "#b8cfe8" : "var(--border)"}`, borderRadius: 4, padding: "1px 6px", fontSize: 10, fontWeight: 700 }}>
//                   {channel.quality}
//                 </span>
//               )}
//             </div>
//             <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 5 }}>
//               <div style={{ width: 7, height: 7, borderRadius: "50%", background: color }} />
//               <span style={{ fontSize: 11, color, fontWeight: 600 }}>{statusLabel}</span>
//               {lastHb && (
//                 <span style={{ fontSize: 11, color: "var(--text-dim)" }}>
//                   · last heartbeat {Math.round(minsSinceHb)}m ago
//                 </span>
//               )}
//             </div>
//           </div>
//           <button onClick={onClose} style={{ background: "none", border: `1px solid var(--border)`, borderRadius: 6, padding: "4px 10px", fontSize: 13, color: "var(--text-dim)", cursor: "pointer", fontFamily: "inherit" }}>×</button>
//         </div>

//         {/* Summary bar */}
//         <div style={{ display: "flex", borderBottom: `1px solid var(--border)`, flexShrink: 0 }}>
//           {[
//             ["Devices",    channel.device_count],
//             ["Affiliates", channel.affiliate_count],
//             ["Quality",    channel.quality || "SD"],
//           ].map(([k, v], i) => (
//             <div key={k} style={{ flex: 1, padding: "10px 16px", borderRight: i < 2 ? `1px solid var(--border)` : "none" }}>
//               <div style={{ fontSize: 10, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 3 }}>{k}</div>
//               <div style={{ fontSize: 18, fontWeight: 700, color: "var(--ink)" }}>{v}</div>
//             </div>
//           ))}
//         </div>

//         {/* Tabs */}
//         <div style={{ display: "flex", borderBottom: `1px solid var(--border)`, flexShrink: 0 }}>
//           {[["live-stats", "⚡ Live Stats"], ["affiliates", "Affiliates"], ["devices", "Devices & Metrics"]].map(([key, label]) => (
//             <button
//               key={key}
//               onClick={() => setTab(key)}
//               style={{ padding: "10px 18px", fontSize: 12, fontWeight: tab === key ? 600 : 400, color: tab === key ? "var(--ink)" : "var(--text-sub)", background: "none", border: "none", borderBottom: `2px solid ${tab === key ? "var(--ink)" : "transparent"}`, cursor: "pointer", fontFamily: "inherit", marginBottom: -1 }}
//             >
//               {label}
//             </button>
//           ))}
//         </div>

//         {/* Tab content */}
//         <div style={{ overflowY: "auto", flex: 1 }}>

//           {/* Live Stats tab */}
//           {tab === "live-stats" && (
//             <div style={{ height: "100%", overflow: "hidden" }}>
//               <HaivisionStatsTab channel={channel} />
//             </div>
//           )}

//           {/* Affiliates tab */}
//           {tab === "affiliates" && (() => {
//             const filteredAffs = affSearch.trim()
//               ? myAffiliates.filter(a =>
//                   a.org_name?.toLowerCase().includes(affSearch.toLowerCase()) ||
//                   a.affiliate_id?.toLowerCase().includes(affSearch.toLowerCase())
//                 )
//               : myAffiliates;
//             return filteredAffs.length === 0 ? (
//               <div style={{ padding: 24, fontSize: 12, color: "var(--text-dim)", textAlign: "center" }}>No affiliates assigned.</div>
//             ) : (
//               <>
//                 <div style={{ padding:"10px 14px 0" }}>
//                   <input value={affSearch} onChange={e => setAffSearch(e.target.value)}
//                     placeholder="Search affiliates…"
//                     style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:6, padding:"6px 10px", fontSize:12, color:"var(--text)", fontFamily:"inherit", outline:"none", width:220 }} />
//                 </div>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ background: "var(--surface-alt)", position: "sticky", top: 0 }}>
//                     {["Affiliate ID", "Organization", "Devices", "Online", "Degraded", "Offline", "Status"].map(h => (
//                       <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", borderBottom: `1px solid var(--border)`, whiteSpace: "nowrap" }}>{h}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredAffs.map((a, i) => (
//                     <tr key={a.affiliate_id} style={{ borderBottom: i < myAffiliates.length - 1 ? `1px solid var(--border)` : "none" }}>
//                       <td style={{ padding: "10px 14px", fontSize: 12, fontFamily: "'IBM Plex Mono', monospace", fontWeight: 600, color: "var(--ink)" }}>{a.affiliate_id}</td>
//                       <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text)" }}>{a.org_name}</td>
//                       <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text-sub)" }}>{a.devices}</td>
//                       <td style={{ padding: "10px 14px", fontSize: 12, color: "#22c55e", fontWeight: 600 }}>{a.online}</td>
//                       <td style={{ padding: "10px 14px", fontSize: 12, color: "#f59e0b", fontWeight: Number(a.degraded) > 0 ? 600 : 400 }}>{a.degraded || 0}</td>
//                       <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text-sub)" }}>{a.offline || 0}</td>
//                       <td style={{ padding: "10px 14px" }}>
//                         <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: a.affiliate_status === "active" ? "#edf7f1" : "#f2f2f0", color: a.affiliate_status === "active" ? "#1a7a42" : "#6b6b67", border: `1px solid ${a.affiliate_status === "active" ? "#b6dfc6" : "#d4d4d0"}`, borderRadius: 4, padding: "2px 7px", fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>
//                           <span style={{ width: 5, height: 5, borderRadius: "50%", background: a.affiliate_status === "active" ? "#1a7a42" : "#6b6b67" }} />
//                           {a.affiliate_status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )
//               </>
//             );
//           })()}

//           {/* Devices & Metrics tab */}
//           {tab === "devices" && (() => {
//             const filteredDevs = devSearch.trim()
//               ? myDevices.filter(d =>
//                   d.device_id?.toLowerCase().includes(devSearch.toLowerCase()) ||
//                   d.org_name?.toLowerCase().includes(devSearch.toLowerCase()) ||
//                   d.mac_address?.toLowerCase().includes(devSearch.toLowerCase())
//                 )
//               : myDevices;
//             return filteredDevs.length === 0 ? (
//               <div style={{ padding: 24, fontSize: 12, color: "var(--text-dim)", textAlign: "center" }}>No devices on this channel.</div>
//             ) : (
//               <>
//                 <div style={{ padding:"10px 14px 0" }}>
//                   <input value={devSearch} onChange={e => setDevSearch(e.target.value)}
//                     placeholder="Search by device ID, affiliate, MAC…"
//                     style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:6, padding:"6px 10px", fontSize:12, color:"var(--text)", fontFamily:"inherit", outline:"none", width:260 }} />
//                 </div>
//               <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
//                 {filteredDevs.map(dev => {
//                   const statusColor = dev.status === "online" ? "#22c55e" : dev.status === "degraded" ? "#f59e0b" : "#6b6b67";
//                   return (
//                     <div key={dev.device_id} style={{ border: `1px solid var(--border)`, borderRadius: 8, overflow: "hidden" }}>
//                       {/* Device header */}
//                       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "var(--surface-alt)", borderBottom: `1px solid var(--border)` }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                           <span style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.device_id}</span>
//                           <span style={{ fontSize: 11, color: "var(--text-sub)" }}>{dev.device_type === "self-srt-connect" ? "" : dev.device_model}</span>
//                           <span style={{ fontSize: 11, color: "var(--text-dim)" }}>{dev.org_name}</span>
//                         </div>
//                         <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: statusColor + "18", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 4, padding: "2px 7px", fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>
//                           <span style={{ width: 5, height: 5, borderRadius: "50%", background: statusColor }} />
//                           {dev.status}
//                         </span>
//                       </div>

//                       {/* Metrics */}
//                       <div style={{ padding: "12px 14px" }}>
//                         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
//                           <MetricBar label="CPU"  value={dev.cpu_usage}  unit="%" />
//                           <MetricBar label="RAM"  value={dev.ram_usage}  unit="%" />
//                           <MetricBar label="Temp" value={dev.temperature} unit="°C" color="#6366f1" />
//                           <MetricBar label="Disk" value={dev.disk_usage} unit="%" color="#6366f1" />
//                         </div>
//                         {dev.last_seen && (
//                           <div style={{ fontSize: 10, color: "var(--text-dim)", marginTop: 6 }}>
//                             Last seen: {new Date(dev.last_seen).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )
//               </>
//             );
//           })()}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Main ──────────────────────────────────────────────────────────────────────
// export default function AdminDashboard({ onNavigate, searchScope = ["affiliate", "device", "channel"] }) {
//   const { mode } = useTheme();
//   const [data, setData]               = useState(null);
//   const [loading, setLoading]         = useState(true);
//   const [error, setError]             = useState(null);
//   const [selectedChannel, setSelectedChannel] = useState(null);
//   const [selectedAffiliateId, setSelectedAffiliateId] = useState(null);
//   const [selectedDeviceId, setSelectedDeviceId]       = useState(null);
//   const [lastRefresh, setLastRefresh] = useState(new Date());
//   const timerRef                      = useRef(null);

//   // ── Global search ──────────────────────────────────────────────────────
//   const [searchQuery, setSearchQuery]   = useState("");
//   const [searchOpen, setSearchOpen]     = useState(false);
//   const [searchPool, setSearchPool]     = useState({ affiliates: [], devices: [], channels: [] });
//   const searchBoxRef = useRef(null);

//   useEffect(() => {
//     const onClick = (e) => {
//       if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
//         setSearchOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", onClick);
//     return () => document.removeEventListener("mousedown", onClick);
//   }, []);

//   const loadSearchPool = async () => {
//     try {
//       const calls = [];
//       const order = [];
//       if (searchScope.includes("affiliate")) { calls.push(api.affiliates.list());     order.push("affiliates"); }
//       if (searchScope.includes("device"))    { calls.push(api.devices.list({}));      order.push("devices");   }
//       if (searchScope.includes("channel"))   { calls.push(api.channels.list());       order.push("channels");  }
//       const results = await Promise.all(calls);
//       const pool = { affiliates: [], devices: [], channels: [] };
//       order.forEach((key, i) => { pool[key] = Array.isArray(results[i]) ? results[i] : []; });
//       setSearchPool(pool);
//     } catch {
//     }
//   };

//   const searchResults = (() => {
//     const q = searchQuery.trim().toLowerCase();
//     if (!q) return { affiliates: [], devices: [], channels: [] };
//     const match = (val) => val && String(val).toLowerCase().includes(q);
//     return {
//       affiliates: searchPool.affiliates.filter(a =>
//         match(a.id) || match(a.org_name) || match(a.contact_name) || match(a.contact_email)
//       ).slice(0, 6),
//       devices: searchPool.devices.filter(d =>
//         match(d.id) || match(d.mac_address) || match(d.ip_address) || match(d.device_model)
//       ).slice(0, 6),
//       channels: searchPool.channels.filter(c =>
//         match(c.id) || match(c.display_name)
//       ).slice(0, 6),
//     };
//   })();
//   const hasResults = searchResults.affiliates.length || searchResults.devices.length || searchResults.channels.length;

//   const goTo = (type, id) => {
//     setSearchOpen(false);
//     setSearchQuery("");

//     if (type === "channel") {
//       const match = data?.channels?.find(c => c.id === id);
//       if (match) { setSelectedChannel(match); return; }
//     }
//     if (type === "affiliate") { setSelectedAffiliateId(id); return; }
//     if (type === "device")    { setSelectedDeviceId(id); return; }

//     if (onNavigate) onNavigate(type, id);
//   };

//   const load = async () => {
//     try {
//       const d = await api.affiliates.dashboard();
//       setData(d);
//       setLastRefresh(new Date());
//       setError(null);
//     } catch (e) {
//       if (handleAuthFailure(e)) return;
//       setError("Couldn't refresh the dashboard. Retrying shortly…");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     load();
//     loadSearchPool();
//     timerRef.current = setInterval(load, 5 * 60 * 1000);
//     return () => clearInterval(timerRef.current);
//   }, []);

//   const cpuData  = data?.sparkline?.map(r => Number(r.avg_cpu))  || [];
//   const ramData  = data?.sparkline?.map(r => Number(r.avg_ram))  || [];
//   const tempData = data?.sparkline?.map(r => Number(r.avg_temp)) || [];

//   if (loading) return (
//     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 300, fontSize: 12, color: "var(--text-dim)" }}>
//       Loading dashboard…
//     </div>
//   );

//   if (error) return (
//     <div style={{ background: "#fdf0f0", border: "1px solid #e8b4b4", borderRadius: 7, padding: "10px 14px", fontSize: 12, color: "#8b1f1f" }}>
//       {error}
//     </div>
//   );

//   return (
//     <>
//       <style>{`
//         @keyframes pulse {
//           0%, 100% { opacity: 1; transform: scale(1); }
//           50%       { opacity: 0.55; transform: scale(1.4); }
//         }
//       `}</style>

//       <div style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}>

//         {/* Header */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, paddingBottom: 14, borderBottom: `1px solid var(--border)` }}>
//           <h1 style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)" }}>System Dashboard</h1>
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             {onNavigate && (
//               <div ref={searchBoxRef} style={{ position: "relative", width: 280 }}>
//                 <input
//                   value={searchQuery}
//                   onChange={(e) => { setSearchQuery(e.target.value); setSearchOpen(true); }}
//                   onFocus={() => setSearchOpen(true)}
//                   placeholder="Search affiliates, devices, channels…"
//                   style={{
//                     width: "100%", boxSizing: "border-box",
//                     background: "var(--surface)", border: `1px solid var(--border)`,
//                     borderRadius: 6, padding: "6px 10px", fontSize: 12,
//                     color: "var(--text)", fontFamily: "inherit", outline: "none",
//                   }}
//                 />
//                 {searchOpen && searchQuery.trim() && (
//                   <div style={{
//                     position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
//                     background: "var(--surface)", border: `1px solid var(--border)`,
//                     borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
//                     maxHeight: 360, overflowY: "auto", zIndex: 50,
//                   }}>
//                     {!hasResults && (
//                       <div style={{ padding: "12px 14px", fontSize: 12, color: "var(--text-dim)" }}>
//                         No matches for "{searchQuery}"
//                       </div>
//                     )}

//                     {searchResults.affiliates.length > 0 && (
//                       <div>
//                         <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
//                           Affiliates
//                         </div>
//                         {searchResults.affiliates.map(a => (
//                           <div key={a.id} onClick={() => goTo("affiliate", a.id)}
//                             style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
//                             onMouseDown={(e) => e.preventDefault()}
//                           >
//                             <div style={{ fontWeight: 600, color: "var(--ink)" }}>{a.org_name}</div>
//                             <div style={{ fontSize: 11, color: "var(--text-sub)", fontFamily: "'IBM Plex Mono', monospace" }}>{a.id}</div>
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {searchResults.devices.length > 0 && (
//                       <div>
//                         <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
//                           Devices
//                         </div>
//                         {searchResults.devices.map(d => (
//                           <div key={d.id} onClick={() => goTo("device", d.id)}
//                             style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
//                             onMouseDown={(e) => e.preventDefault()}
//                           >
//                             <div style={{ fontWeight: 600, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{d.id}</div>
//                             <div style={{ fontSize: 11, color: "var(--text-sub)" }}>{d.mac_address || d.ip_address || "—"}</div>
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {searchResults.channels.length > 0 && (
//                       <div>
//                         <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
//                           Channels
//                         </div>
//                         {searchResults.channels.map(c => (
//                           <div key={c.id} onClick={() => goTo("channel", c.id)}
//                             style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
//                             onMouseDown={(e) => e.preventDefault()}
//                           >
//                             <div style={{ fontWeight: 600, color: "var(--ink)" }}>{c.display_name}</div>
//                             <div style={{ fontSize: 11, color: "var(--text-sub)", fontFamily: "'IBM Plex Mono', monospace" }}>{c.id}</div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             )}
//             <button onClick={load} style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 6, padding: "5px 12px", fontSize: 11, color: "var(--text-sub)", cursor: "pointer", fontFamily: "inherit" }}>
//               Refresh
//             </button>
//           </div>
//         </div>

//         {/* ── Stat cards ─────────────────────────────────────────────────── */}
//         <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
//           <StatCard label="Total Affiliates"  value={data?.summary?.total_affiliates} />
//           <StatCard label="Active Affiliates" value={data?.summary?.active_affiliates} accent="#1a7a42" />
//           <StatCard label="Assigned Devices"  value={data?.devices?.total} />
//           <StatCard label="Online"   value={data?.devices?.online}
//             sub={`${Math.round(Number(data?.devices?.online) / (Number(data?.devices?.total) || 1) * 100)}% of fleet`}
//             accent="#1a7a42" />
//           <StatCard label="Degraded" value={data?.devices?.degraded} accent="#8a5f0a" />
//           <StatCard label="Offline"  value={data?.devices?.offline} />
//         </div>

//         {/* ── Channel speedometers ────────────────────────────────────────── */}
//         <div style={{ marginBottom: 20 }}>
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
//             <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text-sub)", textTransform: "uppercase", letterSpacing: "0.07em" }}>
//               Channel Health — click to inspect
//             </div>
//             <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
//               {[["#22c55e","Active + Heartbeat"], ["#f59e0b","No Heartbeat"], ["#ef4444","Inactive"]].map(([c, l]) => (
//                 <div key={l} style={{ display: "flex", alignItems: "center", gap: 9 }}>
//                   <div style={{ width: 8, height: 8, borderRadius: "50%", background: c }} />
//                   <span style={{ fontSize: 11, color: "var(--text-sub)" }}>{l}</span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {!data?.channels?.length ? (
//             <div style={{ fontSize: 12, color: "var(--text-dim)" }}>No channels found.</div>
//           ) : (
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 12 }}>
//               {data.channels.map(ch => {
//                 const lastHb = ch.last_heartbeat ? new Date(ch.last_heartbeat) : null;
//                 const mins   = lastHb ? (new Date() - lastHb) / 60000 : Infinity;
//                 const color  = ch.status !== "active" ? "#ef4444"
//                              : mins <= 10 ? "#22c55e" : "#f59e0b";
//                 return (
//                   <div key={ch.id} onClick={() => setSelectedChannel(ch)}
//                     style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10,
//                       padding: "14px 16px", cursor: "pointer", transition: "border-color 0.15s" }}
//                     onMouseEnter={e => e.currentTarget.style.borderColor = "var(--ink)"}
//                     onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
//                   >
//                     <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 6 }}>
//                       <div style={{ width: 7, height: 7, borderRadius: "50%", background: color, flexShrink: 0 }} />
//                       <span style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", fontFamily: "monospace" }}>{ch.id}</span>
//                     </div>
//                     <div style={{ fontSize: 11, color: "var(--text-sub)", marginBottom: 8 }}>{ch.display_name}</div>
//                     <div style={{ display: "flex", gap: 12 }}>
//                       <div style={{ fontSize: 10, color: "var(--text-dim)" }}>
//                         <span style={{ fontWeight: 600, color: "var(--ink)" }}>{ch.device_count ?? 0}</span> devices
//                       </div>
//                       <div style={{ fontSize: 10, color: "var(--text-dim)" }}>
//                         <span style={{ fontWeight: 600, color: "var(--ink)" }}>{ch.affiliate_count ?? 0}</span> affiliates
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Channel modal */}
//       {selectedChannel && (
//         <ChannelModal
//           channel={selectedChannel}
//           affiliates={data?.channelAffiliates || []}
//           devices={data?.channelDevices || []}
//           onClose={() => setSelectedChannel(null)}
//         />
//       )}
//       {selectedAffiliateId && (
//         <AffiliateModal affiliateId={selectedAffiliateId} onClose={() => setSelectedAffiliateId(null)} />
//       )}
//       {selectedDeviceId && (
//         <DeviceModal deviceId={selectedDeviceId} onClose={() => setSelectedDeviceId(null)} />
//       )}
//     </>
//   );
// }


import { useState, useEffect, useRef } from "react";
import { api, handleAuthFailure } from "../data/api";
import { useTheme } from "../context/ThemeContext";
import HaivisionStatsTab from "../components/HaivisionStatsTab";

// ── Sparkline ─────────────────────────────────────────────────────────────────
function Sparkline({ data, color, height = 48 }) {
  if (!data || data.length < 2) {
    return <div style={{ height, background: "var(--surface-alt)", borderRadius: 4 }} />;
  }
  const w = 300, h = height;
  const min = Math.min(...data), max = Math.max(...data);
  const range = max - min || 1;
  const pts = data
    .map((v, i) => `${(i / (data.length - 1)) * w},${h - ((v - min) / range) * (h - 6) - 3}`)
    .join(" ");
  const area = `${pts} ${w},${h} 0,${h}`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{ width: "100%", height }} preserveAspectRatio="none">
      <polygon points={area} fill={color} opacity="0.12" />
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// ── Animated speedometer ──────────────────────────────────────────────────────
function Speedometer({ channel, onClick, animKey }) {
  const [animProgress, setAnimProgress] = useState(0);
  const animRef = useRef(null);

  const now = new Date();
  const lastHb = channel.last_heartbeat ? new Date(channel.last_heartbeat) : null;
  const minsSinceHb = lastHb ? (now - lastHb) / 60000 : Infinity;

  let color, label, glow, targetFill;
  if (channel.status !== "active") {
    color = "#ef4444"; label = "Inactive"; glow = "rgba(239,68,68,0.25)"; targetFill = 0.15;
  } else if (minsSinceHb <= 10) {
    color = "#22c55e"; label = "Active"; glow = "rgba(34,197,94,0.25)"; targetFill = 1;
  } else {
    color = "#f59e0b"; label = "No Heartbeat"; glow = "rgba(245,158,11,0.25)"; targetFill = 0.5;
  }

  // Animate from 0 to targetFill on mount
  useEffect(() => {
    setAnimProgress(0);
    let start = null;
    const duration = 1200;
    const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    const step = (ts) => {
      if (!start) start = ts;
      const elapsed = ts - start;
      const progress = Math.min(elapsed / duration, 1);
      setAnimProgress(ease(progress) * targetFill);
      if (progress < 1) animRef.current = requestAnimationFrame(step);
    };
    animRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animRef.current);
  }, [channel.id, targetFill, animKey]);

  const R = 38, cx = 56, cy = 58;
  const toRad = (d) => (d * Math.PI) / 180;
  const START_ANGLE = -210, END_ANGLE = 30;
  const SWEEP = END_ANGLE - START_ANGLE;

  const arcPath = (start, end, r) => {
    const s = { x: cx + r * Math.cos(toRad(start)), y: cy + r * Math.sin(toRad(start)) };
    const e = { x: cx + r * Math.cos(toRad(end)),   y: cy + r * Math.sin(toRad(end))   };
    const large = Math.abs(end - start) > 180 ? 1 : 0;
    return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
  };

  const fillEndAngle = START_ANGLE + SWEEP * animProgress;

  // Needle angle
  const needleAngle = START_ANGLE + SWEEP * animProgress;
  const needleLen = R - 10;
  const nx = cx + needleLen * Math.cos(toRad(needleAngle));
  const ny = cy + needleLen * Math.sin(toRad(needleAngle));

  return (
    <div
      onClick={onClick}
      style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 10, padding: "14px 10px 10px", cursor: "pointer", transition: "border-color 0.18s, box-shadow 0.18s", userSelect: "none" }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.boxShadow = `0 0 0 3px ${glow}`; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.boxShadow = "none"; }}
    >
      <svg viewBox="0 0 112 80" style={{ width: 112, height: 80, overflow: "visible" }}>
        {/* Outer glow ring */}
        {animProgress > 0.9 && channel.status === "active" && minsSinceHb <= 10 && (
          <circle cx={cx} cy={cy} r={R + 10} fill="none" stroke={color} strokeWidth="1" opacity="0.15" />
        )}
        {/* Track background */}
        <path d={arcPath(START_ANGLE, END_ANGLE, R)} fill="none" stroke={"var(--surface-alt)"} strokeWidth="8" strokeLinecap="round" />
        {/* Coloured fill — animated */}
        {animProgress > 0 && (
          <path
            d={arcPath(START_ANGLE, fillEndAngle, R)}
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            style={{ filter: `drop-shadow(0 0 5px ${glow})` }}
          />
        )}
        {/* Tick marks */}
        {[0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1].map((t, i) => {
          const angle = START_ANGLE + SWEEP * t;
          const ir = R - 5, or = R + 3;
          return (
            <line key={i}
              x1={cx + ir * Math.cos(toRad(angle))} y1={cy + ir * Math.sin(toRad(angle))}
              x2={cx + or * Math.cos(toRad(angle))} y2={cy + or * Math.sin(toRad(angle))}
              stroke={"var(--border-strong)"} strokeWidth="1" strokeLinecap="round"
            />
          );
        })}
        {/* Needle */}
        <line x1={cx} y1={cy} x2={nx} y2={ny} stroke={color} strokeWidth="2" strokeLinecap="round" />
        <circle cx={cx} cy={cy} r="4" fill={color} style={{ filter: `drop-shadow(0 0 3px ${glow})` }} />
        <circle cx={cx} cy={cy} r="2" fill="#fff" />
      </svg>

      <div style={{ fontSize: 11, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace", marginBottom: 2 }}>
        {channel.id}
      </div>
      <div style={{ fontSize: 10, color: "var(--text-sub)", marginBottom: 6, maxWidth: 100, textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {channel.display_name}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 4, background: color + "18", border: `1px solid ${color}44`, borderRadius: 20, padding: "2px 8px" }}>
        <div style={{ width: 6, height: 6, borderRadius: "50%", background: color,
          animation: channel.status === "active" && minsSinceHb <= 10 ? "pulse 2s infinite" : "none"
        }} />
        <span style={{ fontSize: 10, fontWeight: 700, color, letterSpacing: "0.04em" }}>{label}</span>
      </div>
      <div style={{ fontSize: 10, color: "var(--text-dim)", marginTop: 5 }}>
        {channel.device_count} device{channel.device_count !== 1 ? "s" : ""}
        {" · "}{channel.affiliate_count} affiliate{channel.affiliate_count !== 1 ? "s" : ""}
      </div>
    </div>
  );
}

// ── Stat card ─────────────────────────────────────────────────────────────────
function StatCard({ label, value, sub, accent }) {
  return (
    <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 9, padding: "16px 18px", flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 11, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: accent || "var(--ink)", fontVariantNumeric: "tabular-nums", lineHeight: 1, letterSpacing: "-0.02em" }}>{value ?? "—"}</div>
      {sub && <div style={{ fontSize: 11, color: "var(--text-sub)", marginTop: 5 }}>{sub}</div>}
    </div>
  );
}

// ── metric bar ───────────────────────────────────────────────────────────
function MetricBar({ label, value, unit, color }) {
  const pct = Math.min(100, Math.max(0, Number(value) || 0));
  const barColor = pct > 85 ? "#ef4444" : pct > 65 ? "#f59e0b" : color || "#22c55e";
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
        <span style={{ fontSize: 10, color: "var(--text-sub)", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</span>
        <span style={{ fontSize: 11, fontWeight: 600, color: "var(--ink)", fontVariantNumeric: "tabular-nums" }}>
          {value != null ? `${Number(value).toFixed(1)}${unit}` : "—"}
        </span>
      </div>
      <div style={{ height: 4, background: "var(--surface-alt)", borderRadius: 2, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: barColor, borderRadius: 2, transition: "width 0.4s" }} />
      </div>
    </div>
  );
}

function AffiliateModal({ affiliateId, onClose }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr]         = useState(null);

  useEffect(() => {
    setLoading(true);
    api.affiliates.detail(affiliateId)
      .then(d => { setData(d); setErr(null); })
      .catch(e => {
        if (handleAuthFailure(e)) return;
        setErr(e.message || "Failed to load affiliate");
      })
      .finally(() => setLoading(false));
  }, [affiliateId]);

  const devices = data?.devices || [];
  const onlinePct = devices.length
    ? Math.round((devices.filter(d => d.status === "online").length / devices.length) * 100)
    : 0;

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
    >
      <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: 560, maxHeight: "82vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
        <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>{data?.affiliate?.org_name || affiliateId}</div>
            <div style={{ fontSize: 11, color: "var(--text-dim)", fontFamily: "'IBM Plex Mono', monospace", marginTop: 2 }}>{affiliateId}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, color: "var(--text-dim)", cursor: "pointer" }}>×</button>
        </div>
        <div style={{ padding: 20, overflowY: "auto" }}>
          {loading ? (
            <div style={{ fontSize: 12, color: "var(--text-dim)", textAlign: "center", padding: "30px 0" }}>Loading…</div>
          ) : err ? (
            <div style={{ fontSize: 12, color: "#8b1f1f" }}>{err}</div>
          ) : (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18, fontSize: 12 }}>
                <div><span style={{ color: "var(--text-dim)" }}>Contact: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.contact_name || "—"}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>Email: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.contact_email || "—"}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>Region: </span><span style={{ color: "var(--ink)" }}>{data.affiliate.region || "—"}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>Status: </span><span style={{ color: data.affiliate.status === "active" ? "#1a7a42" : "var(--text-sub)", fontWeight: 600, textTransform: "capitalize" }}>{data.affiliate.status}</span></div>
              </div>

              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
                Device Fleet Health
              </div>
              <MetricBar label="Devices Online" value={onlinePct} unit="%" />
              <div style={{ fontSize: 11, color: "var(--text-sub)", marginBottom: 18 }}>
                {devices.filter(d => d.status === "online").length} of {devices.length} device(s) online
              </div>

              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>
                Channels ({data.channels?.length || 0})
              </div>
              <div style={{ fontSize: 12, color: "var(--text-sub)", marginBottom: 18 }}>
                {data.channels?.length ? data.channels.map(c => c.display_name).join(", ") : "No channels assigned."}
              </div>

              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>
                Devices ({devices.length})
              </div>
              {devices.length === 0 ? (
                <div style={{ fontSize: 12, color: "var(--text-dim)" }}>No devices assigned.</div>
              ) : devices.map(d => (
                <div key={d.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid var(--border)`, fontSize: 12 }}>
                  <span style={{ fontFamily: "'IBM Plex Mono', monospace", color: "var(--ink)" }}>{d.id}</span>
                  <span style={{ color: d.status === "online" ? "#1a7a42" : "var(--text-sub)", textTransform: "capitalize" }}>{d.status}</span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function DeviceModal({ deviceId, onClose }) {
  const [dev, setDev]         = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr]         = useState(null);

  useEffect(() => {
    setLoading(true);
    api.devices.get(deviceId)
      .then(d => { setDev(d); setErr(null); })
      .catch(e => {
        if (handleAuthFailure(e)) return;
        setErr(e.message || "Failed to load device");
      })
      .finally(() => setLoading(false));
  }, [deviceId]);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
    >
      <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: 480, maxHeight: "82vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
        <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{deviceId}</div>
            {dev && <div style={{ fontSize: 11, color: dev.status === "online" ? "#1a7a42" : "var(--text-sub)", textTransform: "capitalize", marginTop: 2 }}>{dev.status}</div>}
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, color: "var(--text-dim)", cursor: "pointer" }}>×</button>
        </div>
        <div style={{ padding: 20, overflowY: "auto" }}>
          {loading ? (
            <div style={{ fontSize: 12, color: "var(--text-dim)", textAlign: "center", padding: "30px 0" }}>Loading…</div>
          ) : err ? (
            <div style={{ fontSize: 12, color: "#8b1f1f" }}>{err}</div>
          ) : (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18, fontSize: 12 }}>
                <div><span style={{ color: "var(--text-dim)" }}>MAC: </span><span style={{ color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.mac_address || "—"}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>IP: </span><span style={{ color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.ip_address || "—"}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>Model: </span><span style={{ color: "var(--ink)" }}>{dev.device_type === "self-srt-connect" ? "" : (dev.device_model || "—")}</span></div>
                <div><span style={{ color: "var(--text-dim)" }}>Affiliate: </span><span style={{ color: "var(--ink)" }}>{dev.affiliate_id || "Unassigned"}</span></div>
              </div>

              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
                Live Metrics
              </div>
              <MetricBar label="CPU"  value={dev.cpu_usage}   unit="%" />
              <MetricBar label="RAM"  value={dev.ram_usage}   unit="%" />
              <MetricBar label="Disk" value={dev.disk_usage}  unit="%" />
              <MetricBar label="Temp" value={dev.temperature} unit="°C" />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function ChannelModal({ channel, affiliates, devices, onClose }) {
  const [tab, setTab] = useState("live-stats"); // "affiliates" | "devices" | "live-stats"
  const [affSearch, setAffSearch]   = useState("");
  const [devSearch, setDevSearch]   = useState("");

  const now = new Date();
  const lastHb = channel.last_heartbeat ? new Date(channel.last_heartbeat) : null;
  const minsSinceHb = lastHb ? (now - lastHb) / 60000 : Infinity;
  let color, statusLabel;
  if (channel.status !== "active")  { color = "#ef4444"; statusLabel = "Inactive"; }
  else if (minsSinceHb <= 10)       { color = "#22c55e"; statusLabel = "Active — Heartbeat OK"; }
  else                              { color = "#f59e0b"; statusLabel = "Active — No Heartbeat"; }

  // Match against EVERY assigned channel, not just the first. The scalar
  // `channel_id` is a backward-compat field: devices.js defines it as
  // `channels->0->>'channel_id'` and affiliates.js as MIN(channel_id), so on a
  // multi-channel RK3568 it only ever names the lowest-sorted channel. Filtering
  // on it alone hid any device holding this channel in its 2nd..6th slot.
  const holdsChannel = (row) =>
    row.channels?.some(c => c.channel_id === channel.id) ||
    row.channel_ids?.includes(channel.id) ||
    row.channel_id === channel.id;

  const myAffiliates = affiliates.filter(holdsChannel);
  const myDevices    = devices.filter(holdsChannel);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 400, fontFamily: "'DM Sans', system-ui, sans-serif" }}
    >
      <div style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 12, width: 640, maxHeight: "82vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>

        {/* Header */}
        <div style={{ padding: "18px 20px", borderBottom: `1px solid var(--border)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{channel.id}</span>
              <span style={{ fontSize: 13, color: "var(--text-sub)" }}>{channel.display_name}</span>
              {channel.quality && (
                <span style={{ background: channel.quality === "HD" ? "#eef3fb" : "var(--surface-alt)", color: channel.quality === "HD" ? "#1d4e8a" : "var(--text-sub)", border: `1px solid ${channel.quality === "HD" ? "#b8cfe8" : "var(--border)"}`, borderRadius: 4, padding: "1px 6px", fontSize: 10, fontWeight: 700 }}>
                  {channel.quality}
                </span>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 5 }}>
              <div style={{ width: 7, height: 7, borderRadius: "50%", background: color }} />
              <span style={{ fontSize: 11, color, fontWeight: 600 }}>{statusLabel}</span>
              {lastHb && (
                <span style={{ fontSize: 11, color: "var(--text-dim)" }}>
                  · last heartbeat {Math.round(minsSinceHb)}m ago
                </span>
              )}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: `1px solid var(--border)`, borderRadius: 6, padding: "4px 10px", fontSize: 13, color: "var(--text-dim)", cursor: "pointer", fontFamily: "inherit" }}>×</button>
        </div>

        {/* Summary bar */}
        <div style={{ display: "flex", borderBottom: `1px solid var(--border)`, flexShrink: 0 }}>
          {[
            ["Devices",    channel.device_count],
            ["Affiliates", channel.affiliate_count],
            ["Quality",    channel.quality || "SD"],
          ].map(([k, v], i) => (
            <div key={k} style={{ flex: 1, padding: "10px 16px", borderRight: i < 2 ? `1px solid var(--border)` : "none" }}>
              <div style={{ fontSize: 10, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 3 }}>{k}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "var(--ink)" }}>{v}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", borderBottom: `1px solid var(--border)`, flexShrink: 0 }}>
          {[["live-stats", "⚡ Live Stats"],["affiliates", "Affiliates"], ["devices", "Devices & Metrics"] ].map(([key, label]) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              style={{ padding: "10px 18px", fontSize: 12, fontWeight: tab === key ? 600 : 400, color: tab === key ? "var(--ink)" : "var(--text-sub)", background: "none", border: "none", borderBottom: `2px solid ${tab === key ? "var(--ink)" : "transparent"}`, cursor: "pointer", fontFamily: "inherit", marginBottom: -1 }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div style={{ overflowY: "auto", flex: 1 }}>

          {/* Live Stats tab */}
          {tab === "live-stats" && (
            <div style={{ height: "100%", overflow: "hidden" }}>
              <HaivisionStatsTab channel={channel} />
            </div>
          )}

          {/* Affiliates tab */}
          {tab === "affiliates" && (() => {
            const filteredAffs = affSearch.trim()
              ? myAffiliates.filter(a =>
                  a.org_name?.toLowerCase().includes(affSearch.toLowerCase()) ||
                  a.affiliate_id?.toLowerCase().includes(affSearch.toLowerCase())
                )
              : myAffiliates;
            return filteredAffs.length === 0 ? (
              <div style={{ padding: 24, fontSize: 12, color: "var(--text-dim)", textAlign: "center" }}>No affiliates assigned.</div>
            ) : (
              <>
                <div style={{ padding:"10px 14px 0" }}>
                  <input value={affSearch} onChange={e => setAffSearch(e.target.value)}
                    placeholder="Search affiliates…"
                    style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:6, padding:"6px 10px", fontSize:12, color:"var(--text)", fontFamily:"inherit", outline:"none", width:220 }} />
                </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "var(--surface-alt)", position: "sticky", top: 0 }}>
                    {["Affiliate ID", "Organization", "Devices", "Online", "Degraded", "Offline", "Status"].map(h => (
                      <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", borderBottom: `1px solid var(--border)`, whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredAffs.map((a, i) => (
                    <tr key={a.affiliate_id} style={{ borderBottom: i < myAffiliates.length - 1 ? `1px solid var(--border)` : "none" }}>
                      <td style={{ padding: "10px 14px", fontSize: 12, fontFamily: "'IBM Plex Mono', monospace", fontWeight: 600, color: "var(--ink)" }}>{a.affiliate_id}</td>
                      <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text)" }}>{a.org_name}</td>
                      <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text-sub)" }}>{a.devices}</td>
                      <td style={{ padding: "10px 14px", fontSize: 12, color: "#22c55e", fontWeight: 600 }}>{a.online}</td>
                      <td style={{ padding: "10px 14px", fontSize: 12, color: "#f59e0b", fontWeight: Number(a.degraded) > 0 ? 600 : 400 }}>{a.degraded || 0}</td>
                      <td style={{ padding: "10px 14px", fontSize: 12, color: "var(--text-sub)" }}>{a.offline || 0}</td>
                      <td style={{ padding: "10px 14px" }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: a.affiliate_status === "active" ? "#edf7f1" : "#f2f2f0", color: a.affiliate_status === "active" ? "#1a7a42" : "#6b6b67", border: `1px solid ${a.affiliate_status === "active" ? "#b6dfc6" : "#d4d4d0"}`, borderRadius: 4, padding: "2px 7px", fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>
                          <span style={{ width: 5, height: 5, borderRadius: "50%", background: a.affiliate_status === "active" ? "#1a7a42" : "#6b6b67" }} />
                          {a.affiliate_status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
              </>
            );
          })()}

          {/* Devices & Metrics tab */}
          {tab === "devices" && (() => {
            const filteredDevs = devSearch.trim()
              ? myDevices.filter(d =>
                  d.device_id?.toLowerCase().includes(devSearch.toLowerCase()) ||
                  d.org_name?.toLowerCase().includes(devSearch.toLowerCase()) ||
                  d.mac_address?.toLowerCase().includes(devSearch.toLowerCase())
                )
              : myDevices;
            return filteredDevs.length === 0 ? (
              <div style={{ padding: 24, fontSize: 12, color: "var(--text-dim)", textAlign: "center" }}>No devices on this channel.</div>
            ) : (
              <>
                <div style={{ padding:"10px 14px 0" }}>
                  <input value={devSearch} onChange={e => setDevSearch(e.target.value)}
                    placeholder="Search by device ID, affiliate, MAC…"
                    style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:6, padding:"6px 10px", fontSize:12, color:"var(--text)", fontFamily:"inherit", outline:"none", width:260 }} />
                </div>
              <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
                {filteredDevs.map(dev => {
                  const statusColor = dev.status === "online" ? "#22c55e" : dev.status === "degraded" ? "#f59e0b" : "#6b6b67";
                  return (
                    <div key={dev.device_id} style={{ border: `1px solid var(--border)`, borderRadius: 8, overflow: "hidden" }}>
                      {/* Device header */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "var(--surface-alt)", borderBottom: `1px solid var(--border)` }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{dev.device_id}</span>
                          <span style={{ fontSize: 11, color: "var(--text-sub)" }}>{dev.device_type === "self-srt-connect" ? "" : dev.device_model}</span>
                          <span style={{ fontSize: 11, color: "var(--text-dim)" }}>{dev.org_name}</span>
                        </div>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: statusColor + "18", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 4, padding: "2px 7px", fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>
                          <span style={{ width: 5, height: 5, borderRadius: "50%", background: statusColor }} />
                          {dev.status}
                        </span>
                      </div>

                      {/* Metrics */}
                      <div style={{ padding: "12px 14px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
                          <MetricBar label="CPU"  value={dev.cpu_usage}  unit="%" />
                          <MetricBar label="RAM"  value={dev.ram_usage}  unit="%" />
                          <MetricBar label="Temp" value={dev.temperature} unit="°C" color="#6366f1" />
                          <MetricBar label="Disk" value={dev.disk_usage} unit="%" color="#6366f1" />
                        </div>
                        {dev.last_seen && (
                          <div style={{ fontSize: 10, color: "var(--text-dim)", marginTop: 6 }}>
                            Last seen: {new Date(dev.last_seen).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )
              </>
            );
          })()}
        </div>
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function AdminDashboard({ onNavigate, searchScope = ["affiliate", "device", "channel"] }) {
  const { mode } = useTheme();
  const [data, setData]               = useState(null);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [selectedAffiliateId, setSelectedAffiliateId] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId]       = useState(null);
  const [lastRefresh, setLastRefresh] = useState(new Date());
  const timerRef                      = useRef(null);

  // ── Global search ──────────────────────────────────────────────────────
  const [searchQuery, setSearchQuery]   = useState("");
  const [searchOpen, setSearchOpen]     = useState(false);
  const [searchPool, setSearchPool]     = useState({ affiliates: [], devices: [], channels: [] });
  const searchBoxRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const loadSearchPool = async () => {
    try {
      const calls = [];
      const order = [];
      if (searchScope.includes("affiliate")) { calls.push(api.affiliates.list());     order.push("affiliates"); }
      if (searchScope.includes("device"))    { calls.push(api.devices.list({}));      order.push("devices");   }
      if (searchScope.includes("channel"))   { calls.push(api.channels.list());       order.push("channels");  }
      const results = await Promise.all(calls);
      const pool = { affiliates: [], devices: [], channels: [] };
      order.forEach((key, i) => { pool[key] = Array.isArray(results[i]) ? results[i] : []; });
      setSearchPool(pool);
    } catch {
    }
  };

  const searchResults = (() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return { affiliates: [], devices: [], channels: [] };
    const match = (val) => val && String(val).toLowerCase().includes(q);
    return {
      affiliates: searchPool.affiliates.filter(a =>
        match(a.id) || match(a.org_name) || match(a.contact_name) || match(a.contact_email)
      ).slice(0, 6),
      devices: searchPool.devices.filter(d =>
        match(d.id) || match(d.mac_address) || match(d.ip_address) || match(d.device_model)
      ).slice(0, 6),
      channels: searchPool.channels.filter(c =>
        match(c.id) || match(c.display_name)
      ).slice(0, 6),
    };
  })();
  const hasResults = searchResults.affiliates.length || searchResults.devices.length || searchResults.channels.length;

  const goTo = (type, id) => {
    setSearchOpen(false);
    setSearchQuery("");

    if (type === "channel") {
      const match = data?.channels?.find(c => c.id === id);
      if (match) { setSelectedChannel(match); return; }
    }
    if (type === "affiliate") { setSelectedAffiliateId(id); return; }
    if (type === "device")    { setSelectedDeviceId(id); return; }

    if (onNavigate) onNavigate(type, id);
  };

  const load = async () => {
    try {
      const d = await api.affiliates.dashboard();
      setData(d);
      setLastRefresh(new Date());
      setError(null);
    } catch (e) {
      if (handleAuthFailure(e)) return;
      setError("Couldn't refresh the dashboard. Retrying shortly…");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    loadSearchPool();
    timerRef.current = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  const cpuData  = data?.sparkline?.map(r => Number(r.avg_cpu))  || [];
  const ramData  = data?.sparkline?.map(r => Number(r.avg_ram))  || [];
  const tempData = data?.sparkline?.map(r => Number(r.avg_temp)) || [];

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 300, fontSize: 12, color: "var(--text-dim)" }}>
      Loading dashboard…
    </div>
  );

  if (error) return (
    <div style={{ background: "#fdf0f0", border: "1px solid #e8b4b4", borderRadius: 7, padding: "10px 14px", fontSize: 12, color: "#8b1f1f" }}>
      {error}
    </div>
  );

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.55; transform: scale(1.4); }
        }
      `}</style>

      <div style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, paddingBottom: 14, borderBottom: `1px solid var(--border)` }}>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)" }}>System Dashboard</h1>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {onNavigate && (
              <div ref={searchBoxRef} style={{ position: "relative", width: 280 }}>
                <input
                  value={searchQuery}
                  onChange={(e) => { setSearchQuery(e.target.value); setSearchOpen(true); }}
                  onFocus={() => setSearchOpen(true)}
                  placeholder="Search affiliates, devices, channels…"
                  style={{
                    width: "100%", boxSizing: "border-box",
                    background: "var(--surface)", border: `1px solid var(--border)`,
                    borderRadius: 6, padding: "6px 10px", fontSize: 12,
                    color: "var(--text)", fontFamily: "inherit", outline: "none",
                  }}
                />
                {searchOpen && searchQuery.trim() && (
                  <div style={{
                    position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
                    background: "var(--surface)", border: `1px solid var(--border)`,
                    borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    maxHeight: 360, overflowY: "auto", zIndex: 50,
                  }}>
                    {!hasResults && (
                      <div style={{ padding: "12px 14px", fontSize: 12, color: "var(--text-dim)" }}>
                        No matches for "{searchQuery}"
                      </div>
                    )}

                    {searchResults.affiliates.length > 0 && (
                      <div>
                        <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                          Affiliates
                        </div>
                        {searchResults.affiliates.map(a => (
                          <div key={a.id} onClick={() => goTo("affiliate", a.id)}
                            style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <div style={{ fontWeight: 600, color: "var(--ink)" }}>{a.org_name}</div>
                            <div style={{ fontSize: 11, color: "var(--text-sub)", fontFamily: "'IBM Plex Mono', monospace" }}>{a.id}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {searchResults.devices.length > 0 && (
                      <div>
                        <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                          Devices
                        </div>
                        {searchResults.devices.map(d => (
                          <div key={d.id} onClick={() => goTo("device", d.id)}
                            style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <div style={{ fontWeight: 600, color: "var(--ink)", fontFamily: "'IBM Plex Mono', monospace" }}>{d.id}</div>
                            <div style={{ fontSize: 11, color: "var(--text-sub)" }}>{d.mac_address || d.ip_address || "—"}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {searchResults.channels.length > 0 && (
                      <div>
                        <div style={{ padding: "8px 14px 4px", fontSize: 10, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                          Channels
                        </div>
                        {searchResults.channels.map(c => (
                          <div key={c.id} onClick={() => goTo("channel", c.id)}
                            style={{ padding: "8px 14px", cursor: "pointer", fontSize: 12 }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <div style={{ fontWeight: 600, color: "var(--ink)" }}>{c.display_name}</div>
                            <div style={{ fontSize: 11, color: "var(--text-sub)", fontFamily: "'IBM Plex Mono', monospace" }}>{c.id}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            <button onClick={load} style={{ background: "var(--surface)", border: `1px solid var(--border)`, borderRadius: 6, padding: "5px 12px", fontSize: 11, color: "var(--text-sub)", cursor: "pointer", fontFamily: "inherit" }}>
              Refresh
            </button>
          </div>
        </div>

        {/* ── Stat cards ─────────────────────────────────────────────────── */}
        <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
          <StatCard label="Total Affiliates"  value={data?.summary?.total_affiliates} />
          <StatCard label="Active Affiliates" value={data?.summary?.active_affiliates} accent="#1a7a42" />
          <StatCard label="Assigned Devices"  value={data?.devices?.total} />
          <StatCard label="Online"   value={data?.devices?.online}
            sub={`${Math.round(Number(data?.devices?.online) / (Number(data?.devices?.total) || 1) * 100)}% of fleet`}
            accent="#1a7a42" />
          <StatCard label="Degraded" value={data?.devices?.degraded} accent="#8a5f0a" />
          <StatCard label="Offline"  value={data?.devices?.offline} />
        </div>

        {/* ── Channel speedometers ────────────────────────────────────────── */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text-sub)", textTransform: "uppercase", letterSpacing: "0.07em" }}>
              Channel Health — click to inspect
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              {[["#22c55e","Active + Heartbeat"], ["#f59e0b","No Heartbeat"], ["#ef4444","Inactive"]].map(([c, l]) => (
                <div key={l} style={{ display: "flex", alignItems: "center", gap: 9 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: c }} />
                  <span style={{ fontSize: 11, color: "var(--text-sub)" }}>{l}</span>
                </div>
              ))}
            </div>
          </div>

          {!data?.channels?.length ? (
            <div style={{ fontSize: 12, color: "var(--text-dim)" }}>No channels found.</div>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 18 }}>
              {data.channels.map(ch => {
                const lastHb = ch.last_heartbeat ? new Date(ch.last_heartbeat) : null;
                const mins   = lastHb ? (new Date() - lastHb) / 60000 : Infinity;
                const color  = ch.status !== "active" ? "#ef4444"
                             : mins <= 10 ? "#22c55e" : "#f59e0b";
                return (
                  <div key={ch.id} onClick={() => setSelectedChannel(ch)}
                    style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10,
                      padding: "14px 16px", cursor: "pointer", transition: "border-color 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = "var(--ink)"}
                    onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 6 }}>
                      <div style={{ width: 7, height: 7, borderRadius: "50%", background: color, flexShrink: 0 }} />
                      <span style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", fontFamily: "monospace" }}>{ch.id}</span>
                    </div>
                    <div style={{ fontSize: 11, color: "var(--text-sub)", marginBottom: 8 }}>{ch.display_name}</div>
                    <div style={{ display: "flex", gap: 12 }}>
                      <div style={{ fontSize: 10, color: "var(--text-dim)" }}>
                        <span style={{ fontWeight: 600, color: "var(--ink)" }}>{ch.device_count ?? 0}</span> devices
                      </div>
                      <div style={{ fontSize: 10, color: "var(--text-dim)" }}>
                        <span style={{ fontWeight: 600, color: "var(--ink)" }}>{ch.affiliate_count ?? 0}</span> affiliates
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Channel modal */}
      {selectedChannel && (
        <ChannelModal
          channel={selectedChannel}
          affiliates={data?.channelAffiliates || []}
          devices={data?.channelDevices || []}
          onClose={() => setSelectedChannel(null)}
        />
      )}
      {selectedAffiliateId && (
        <AffiliateModal affiliateId={selectedAffiliateId} onClose={() => setSelectedAffiliateId(null)} />
      )}
      {selectedDeviceId && (
        <DeviceModal deviceId={selectedDeviceId} onClose={() => setSelectedDeviceId(null)} />
      )}
    </>
  );
}

